import { useCallback } from "react";

import { apiClient, StatusEnum } from "../../shared";
import { CustomAutocomplete } from "../../ui";

export const PaymentTermSelect = (props) => {
  const fetchPaymentTerms = useCallback(async () => {
    const {
      data: { data },
    } = await apiClient.get("payment-terms", {
      params: {
        status: StatusEnum.ACTIVE,
      },
    });
    return data;
  }, []);

  return (
    <CustomAutocomplete
      fetchOptions={fetchPaymentTerms}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      {...props}
    />
  );
};
